import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class InstanaService {
  private readonly instanaSessionKey = 'in-session';
  constructor(private logger: NGXLogger) {
    this.startSessionTracking();
  }

  startSessionTracking(sessionInactivityTimeout?: number, sessionTerminationTimeout?: number) {
    InstanaService.callIneum(() => {
      this.logger.debug('Start session tracking');
      ineum('trackSessions', sessionInactivityTimeout, sessionTerminationTimeout);
    });
  }

  terminateSessionTracking() {
    InstanaService.callIneum(() => {
      this.logger.debug('Start session tracking');
      ineum('terminateSession');
    });
  }
  reportUser(id: string) {
    InstanaService.callIneum(() => {
      this.logger.debug(`Set user: ${id}`);
      ineum('user', id);
    });
  }

  reportPage(pageName: string) {
    InstanaService.callIneum(() => {
      this.logger.debug(`Set page: ${pageName}`);
      ineum('page', pageName);
    });
  }

  reportError(error: string | Error) {
    InstanaService.callIneum(() => {
      this.logger.debug(`Report error: ${error}`);
      ineum('reportError', error);
    });
  }

  reportMetadataObject(obj: { [key: string]: string | number | boolean }) {
    for (let [key, value] of Object.entries(obj)) {
      this.reportMetadata(key, value);
    }
  }

  reportMetadata(key: string, value: string | number | boolean) {
    InstanaService.callIneum(() => {
      this.logger.debug(`Add metadata: ${key}=${value}`);
      ineum('meta', key, value);
    });
  }

  private static callIneum(func: () => void) {
    if (typeof ineum === 'function') {
      func();
    }
  }
}
